let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8zZNc")).then(() => parcelRequire('kSbNs'));